import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TailSpin } from 'react-loader-spinner';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme, props) => {
    const imageSizeStyles = {
        width: props.width || '100%',
        height: props.height || '100%',
        maxWidth: '100%',
        maxHeight: '100%',
    };
    if (props.variant === 'square')
        imageSizeStyles.aspectRatio = '1';
    return {
        imageContainer: {
            width: '100%',
            height: '100%',
            position: 'relative',
        },
        image: {
            ...imageSizeStyles,
            objectFit: 'cover',
            borderRadius: theme.shape.borderRadius,
        },
        loaderContainer: {
            ...imageSizeStyles,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            gap: theme.spacing(1),
            color: theme.palette.iisightDefaultText,
        },
    };
});
export const Image = ({ name, src: url, ...styleProps }) => {
    const { classes, theme } = useStyles(styleProps);
    const [src, setSrc] = useState();
    const { t } = useTranslation();
    useEffect(() => {
        fetch(url)
            .then((res) => res.blob())
            .then((blob) => setSrc(URL.createObjectURL(blob)));
    }, [url]);
    return (React.createElement("div", { className: classes.imageContainer }, src ? (React.createElement("img", { className: classes.image, src: src, alt: name })) : (React.createElement("div", { className: classes.loaderContainer },
        React.createElement(TailSpin, { color: theme.palette.iisightGray200, height: 28, width: 28, strokeWidth: 3 }),
        React.createElement("div", null, t('chat.media.imageLoading'))))));
};
